module.exports = __webpack_public_path__ + "static/media/boyle-cheer.0000efac.webp";